// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_Rvg","cls2":"PaywallPage-cls2_EYe PaywallPage-cls1_Rvg"};